import * as React from "react";
import { graphql } from "gatsby";
// import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/layout";
import Seo from "../components/seo";
import HeroSectionStatic from "../sections/Home/HeroSectionStatic";
import ProductSection from "../sections/Home/ProductSection";
import WelcomeSection from "../sections/Home/WelcomeSection";
// import FacebookPosts from "../components/FacebookPosts";
// import FaqAccordionHome from "../components/FaqAccordionHome";
import PageBlock from "../components/PageBlock/PageBlock";
// import { Section, SectionDescription, Container, SectionTitle, FaqGrid, FaqLeftGrid, FaqRightGrid, } from "../components/Section";
import ProductCategoryListSection from "../sections/ProductCategoryListSection";
import DurableSection from "../sections/Home/DurableSection";
import BuildingSection from "../sections/Home/BuildingSection";

const IndexPage = ({ location, data }) => {
  const productCategoryListOption = data.allContentfulPageCategoryList.edges[0].node;
  return (
    <Layout location={location}>
      <Seo
        title="High-Quality Engineered Metal Buildings & Steel Structures"
        description="Shop durable, prefabricated metal buildings made in the USA with fast delivery. We provide various buildings, from metal garages, carports, to metal barns."
      />
      <HeroSectionStatic />
      <DurableSection />
      <ProductSection data={data.allContentfulProduct.edges} />
      <ProductCategoryListSection data={productCategoryListOption} />
      <BuildingSection />
      <WelcomeSection />
      <PageBlock />
      {data.contentfulPage.blocks.map((data, i) => (
        <PageBlock data={data} key={i} />
      ))}
    </Layout>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageQuery {
    allContentfulPageCategoryList(filter: { pageName: { eq: "Home" } }) {
      edges {
        node {
          heading
          subheading
          categories {
            title
            heroImage {
              gatsbyImageData(placeholder: BLURRED, quality: 100)
            }
            thumbnail {
              gatsbyImageData(placeholder: BLURRED, quality: 100)
            }
          }
        }
      }
    }
    allContentfulProduct(
      sort: { fields: skuNumber, order: ASC }
      limit: 24
      filter: {isPopular: {eq: true}}
    ) {
      edges {
        node {
          id
          url
          rto
          financingAvailable
          skuNumber
          title
          image {
            gatsbyImageData(quality: 50, placeholder: BLURRED)
            fluid {
              srcWebp
            }
          }
          price
          width
          length
          height
          city
          state
          zipcode
          location {
            lat
            lon
          }
          buildingCondition
          description {
            childMarkdownRemark {
              html
            }
          }
          specifications {
            childMarkdownRemark {
              html
            }
          }
          productCategories {
            title
          }
          buildingTags
          roofStyleType
          manufacturer
          gaugeTubing
          gaugePanels
          isPopular
        }
      }
    }
    contentfulPage(name: {eq: "homepage"}) {
      id
      blocks {
        title
        type
        contents {
          id
          type
          question
          answer {
            id
            childMarkdownRemark {
              html
            }
          }
        }
        subTitle {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
